module.exports = __webpack_public_path__ + "assets/img/cart-empty.78281430.png";